'use client';

import { useCallback, useEffect, useRef, useState } from 'react';

type UseCopyToClipboardOptions = {
  readonly resetDelayMs?: number;
};

export function useCopyToClipboard({ resetDelayMs = 1500 }: UseCopyToClipboardOptions = {}) {
  const [copied, setCopied] = useState(false);
  const resetTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (resetTimer.current) clearTimeout(resetTimer.current);
    };
  }, []);

  const copy = useCallback(
    async (text: string) => {
      try {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        if (resetTimer.current) clearTimeout(resetTimer.current);
        resetTimer.current = setTimeout(() => setCopied(false), resetDelayMs);
      } catch {
        // Clipboard API can reject when the document isn't focused or in unsupported contexts.
      }
    },
    [resetDelayMs],
  );

  return { copied, copy };
}
